import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component';
import { toast } from 'react-toastify';
import moment from 'moment';

import styled from '@emotion/styled';

import chzIcon from '../../../assets/images/chestnyznak.svg';

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  font-size: 13px;
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .returns-video-block {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 12px;
    li {
      margin-bottom: 2px;
    }
    i {
      font-size: 20px;
      margin-right: 10px;
    }
    a {
      color: #4fc6e1;
      display: block;
    }
  }
  .link-list {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 12px;
    li {
      margin-bottom: 2px;
    }
    a {
      color: #4fc6e1;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      display: block;
    }
  }
  .card-title {
    padding-top: 4px;
    padding-bottom: 13px;
  }
  .header-title {
    font-size: 16px;
  }

  .returns-wrapper {
    > div {
      padding: 12px;
      background: #f6f8f9;
      border: 1px solid #e0e9ee;
      box-sizing: border-box;
      border-radius: 4px;
      color: #72747b;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .returns-top {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }
  }

  .returns-name {
    font-weight: 500;
    margin-bottom: 4px;
  }

  .returns-item-name {
    margin-right: 15px;
    font-weight: 500;
    margin-bottom: 2px;
    max-width: 450px;
    @media (max-width: 1610px) {
      max-width: 300px;
    }
    @media (max-width: 1500px) {
      max-width: 250px;
    }
  }

  .returns-item-defectreason {
    font-size: 10px;
    text-transform: uppercase;
  }

  .show-returns-info-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 500;
    margin-top: 10px;
    i {
      font-size: 20px;
      margin-left: 4px;
      cursor: pointer;
    }
  }

  .returns-right {
    display: flex;
  }

  .returns-item-right {
    display: flex;
  }

  .returns-item-left {
    display: flex;
    flex-direction: column;
  }

  .returns-quantity,
  .returns-defectmark {
    margin-left: 24px;
    min-width: 81px;
    display: flex;
    justify-content: flex-end;
    font-weight: 500;
  }
  .returns-defectmark {
    margin-left: 10px;
    min-width: 60px;
  }

  .returns-item-main {
    justify-content: space-between;
    flex-wrap: wrap;
    display: flex;
    @media (max-width: 1500px) and (min-width: 1300px) {
      flex-direction: column;
      .returns-item-right {
        flex-direction: column;
        .returns-quantity,
        .returns-defectmark {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
    @media (max-width: 1200px) and (min-width: 1025px) {
      flex-direction: column;
      .returns-item-right,
      .returns-defectmark {
        flex-direction: column;
        .returns-quantity {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
    @media (max-width: 500px) {
      flex-direction: column;
      .returns-item-right {
        flex-direction: column;
        .returns-quantity,
        .returns-defectmark {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
  }

  .returns-item-string {
    display: flex;

    p {
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 -13px 0 0;
      transition: 0.15s;
    }

    .fe-copy {
      align-self: center;
      cursor: pointer;
      opacity: 0;
      transition: 0.15s;
    }

    &:hover {
      p {
        max-width: calc(100% - 21px);
        margin: 0 8px 0 0;
      }

      .fe-copy {
        opacity: 1;
      }
    }
  }

  .returns-block-top {
    margin-bottom: 8px;
    color: #969cad;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    i {
      margin-right: 8px;
      font-size: 13px;
    }
  }

  a {
    text-decoration: underline;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 4px;
  }

  .returns-items {
    margin-top: 12px;
    border-top: 1px solid #ebebeb;
    padding-top: 12px;
  }
`;

const ReturnsBlock = (props) => {
  const { currentOrder } = props;

  const { returns } = currentOrder;

  const [opened, setOpened] = useState([]);

  const handleTogglePacking = (i) => {
    const newArr = opened.slice();
    const currentIndex = opened.indexOf(i);
    if (currentIndex === -1) {
      newArr.push(i);
    } else {
      newArr.splice(currentIndex, 1);
    }
    setOpened(newArr);
  };

  return (
    <Wrapper className="card-box returns">
      <div style={{ display: 'flex' }} className="card-title">
        <h4 className="header-title">Возвраты</h4>
      </div>
      <div className="returns-wrapper card-content border-top pt-3">
        {returns.map((r, i) => (
          <div key={`${r.number}-${i}`}>
            <div className="returns-top">
              <div>
                <div className="returns-name">{r.type === 'RETURN' ? 'Возврат' : 'Рекламация'}</div>
                <div className="parameters">
                  <span>{r.date ? moment(r.date).format('DD-MM-YYYY HH:mm:ss') : null}</span>
                </div>
              </div>
              <div className="show-returns-info-button" onClick={() => handleTogglePacking(i)}>
                <div>Позиции</div>
                <i className={opened.indexOf(i) === -1 ? 'fe-eye' : 'fe-eye-off'} />
              </div>
            </div>
            <div className="row">
              {r?.returnUnpackingVideos?.length ? (
                <div className="col-sm-6">
                  <div className="returns-block-top">
                    <i className="fe-video" />
                    Видео-материалы
                  </div>
                  <ul className="returns-video-block">
                    {r.returnUnpackingVideos.map((v, i) => (
                      <li>
                        <a
                          key={v}
                          href={v}
                          target="_blank"
                          rel="noopener noreferrer"
                        >{`Видео приемки возврата ${i ? i + 1 : ``}`}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
              {r.files?.length ? (
                <div className="col-sm-6">
                  <div className="returns-block-top">
                    <i className="fe-file-text" />
                    Документы
                  </div>
                  <ul className="link-list">
                    {r.files.map((f) => (
                      <li key={f.url}>
                        <a target="_blank" href={f.url} rel="noopener noreferrer">
                          {f.fileName}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>

            {opened.indexOf(i) !== -1 && r.items && r.items.length ? (
              <div className="returns-items">
                {r.items.map((item, i) => (
                  <div key={`return-${i}`}>
                    <div className="returns-item-main">
                      <div className="returns-item-left">
                        <div className="returns-item-name">{item.name}</div>
                        <div className="returns-item-defectreason">
                          {' '}
                          {item.defective === true ? 'Брак: ' + item.defectiveReason : null}{' '}
                        </div>
                      </div>
                      <div className="returns-item-right">
                        <div>{item.barcode}</div>
                        <div className="returns-quantity">{`${item.quantity} шт.`}</div>
                        <div className="returns-defectmark">
                          {item.defective === true ? 'Б' : null}
                          {item.defective === true && item.reclamation === true ? ' | ' : null}
                          {item.reclamation === true ? 'Р' : null}
                        </div>
                      </div>
                    </div>
                    <p style={{ marginBottom: '3px' }}>{item?.variantId}</p>
                    {(item?.accountingAttributes ?? []).map((attr) => (
                      <div
                        className="returns-item-string"
                        key={attr.code}
                        style={{ color: '#72747ba8' }}
                      >
                        <p title={attr.stringValue}>
                          {attr.code === 'chestnyznak' ? (
                            <img src={chzIcon} style={{ marginTop: '-2px' }} />
                          ) : (
                            `${attr.code}:`
                          )}
                          {` ${attr.stringValue}`}
                        </p>
                        <CopyToClipboard
                          text={attr.stringValue}
                          onCopy={() => toast.info(`Номер атрибута скопирован`)}
                        >
                          <i className="fe-copy" />
                        </CopyToClipboard>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default ReturnsBlock;
